import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import organizationList from '../modules/organizationList/organizationReducer'
import authtoken from '../modules/authtoken' // 登录人信息
import ControlformState from '../modules/ControlformState' // 控制表单
import treeReducer from '../components/TreeAll/treeReducer' // tree结构
import pageCache from '../modules/pagecache' // page 缓存
import routerModules from '../modules/routerModules' // 路由
import homeData from '../modules/homedata'
import dictData from '../modules/dict' // 字典数据
import addfinancialreconciliation from '../pages/financialreconciliationEdit/reducer'
import addpaymentrequest from '../pages/add-payment-request/reducer'
import newBatchAddReducer from '../pages/new-batchadd/reducer'
import goodsReducer from '../modules/goodsdetailmodules/reducer'
import { reducer as myReuestReducer } from '../pages/mylaunch/launchgoods/hooks'
// import { reducer as openInvoiceReducer } from '../pages/addinvoice/hooks'
/**
 * 装载各 Reducer 注意key值
 */
const createRootReducer = (history: any) => {
  const appReducer = combineReducers({
    router: connectRouter(history),
    authtoken: authtoken, // 登录人信息
    treeReducer: treeReducer, // 树数据
    pageCache: pageCache,
    routerModules: routerModules,
    ControlformState: ControlformState,
    organizationList: organizationList, // 组织列表
    homeData: homeData, // getEnterpriseInfo 获取的信息
    dictData: dictData, // 字典数据
    addfinancialreconciliation: addfinancialreconciliation, // 新增对账单
    addpaymentrequest: addpaymentrequest, // 新增付款
    newBacthAddReducer: newBatchAddReducer,
    goodsReducer, // 物料
    myReuestReducer,
    // openInvoiceReducer,
  })
  const rootReducer = (state: any, action: any) => {
    let newState = state
    // 重置所有状态
    if (action.type === 'RESET_REDUX') {
      newState = undefined
    }
    return appReducer(newState, action)
  }
  return rootReducer
}

export default createRootReducer
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import organizationList from '../modules/organizationList/organizationReducer'
import authtoken from '../modules/authtoken' // 登录人信息
import ControlformState from '../modules/ControlformState' // 控制表单
import treeReducer from '../components/TreeAll/treeReducer' // tree结构
import pageCache from '../modules/pagecache' // page 缓存
import routerModules from '../modules/routerModules' // 路由
import homeData from '../modules/homedata'
import dictData from '../modules/dict' // 字典数据
import addfinancialreconciliation from '../pages/financialreconciliationEdit/reducer'
import addpaymentrequest from '../pages/add-payment-request/reducer'
import newBatchAddReducer from '../pages/new-batchadd/reducer'
import goodsReducer from '../modules/goodsdetailmodules/reducer'
import { reducer as myReuestReducer } from '../pages/mylaunch/launchgoods/hooks'
// import { reducer as openInvoiceReducer } from '../pages/addinvoice/hooks'
/**
 * 装载各 Reducer 注意key值
 */
const createRootReducer = (history: any) => {
  const appReducer = combineReducers({
    router: connectRouter(history),
    authtoken: authtoken, // 登录人信息
    treeReducer: treeReducer, // 树数据
    pageCache: pageCache,
    routerModules: routerModules,
    ControlformState: ControlformState,
    organizationList: organizationList, // 组织列表
    homeData: homeData, // getEnterpriseInfo 获取的信息
    dictData: dictData, // 字典数据
    addfinancialreconciliation: addfinancialreconciliation, // 新增对账单
    addpaymentrequest: addpaymentrequest, // 新增付款
    newBacthAddReducer: newBatchAddReducer,
    goodsReducer, // 物料
    myReuestReducer,
    // openInvoiceReducer,
  })
  const rootReducer = (state: any, action: any) => {
    let newState = state
    // 重置所有状态
    if (action.type === 'RESET_REDUX') {
      newState = undefined
    }
    return appReducer(newState, action)
  }
  return rootReducer
}

export default createRootReducer
